export default __webpack_public_path__ + "static/media/svg-signin.a240dd27.svg";